import getInstance from '@/external-libs/axios';

/**
 * Utils
 */
import { resetPasswordURL } from '@/src/constants/urls/apiGatewayURLs';
import ServiceResponse from '@/src/models/ServiceResponse';

async function resetPassword({ password, hash }) {
  try {
    if (!password || !hash)
      return new ServiceResponse({
        error: 'password and hash param is required',
      });

    const axios = getInstance();
    await axios.post(resetPasswordURL, { newPassword: password, hash });

    return new ServiceResponse({ success: true });
  } catch (error) {
    return new ServiceResponse({ error });
  }
}

export default resetPassword;
